import { ApiType } from 'src/Types/ApiType'

import { callApiGet } from 'src/msGraphClient'
import config from 'src/Config/Config'

const { ACCESS_GROUPS } = config.API_FRAGMENTS[ApiType.APIM]

export const getAccessGroups = () => callApiGet<string[]>(`${ACCESS_GROUPS}`, ApiType.APIM)
